import { useState, useEffect } from "react";
import logo from "./logo.png";

export default function MouseLabs() {
  const [visible, setVisible] = useState(false);
  const [lineVisible, setLineVisible] = useState(false);
  const [textVisible, setTextVisible] = useState(false);
  const [emailVisible, setEmailVisible] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setVisible(true), 100);
    const t2 = setTimeout(() => setLineVisible(true), 600);
    const t3 = setTimeout(() => setTextVisible(true), 900);
    const t4 = setTimeout(() => setEmailVisible(true), 1300);
    return () => [t1, t2, t3, t4].forEach(clearTimeout);
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      backgroundColor: "#f8f6f1",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Georgia', 'Times New Roman', serif",
      padding: "2rem",
      position: "relative",
      overflow: "hidden",
    }}>
      {/* Subtle grain texture overlay */}
      <div style={{
        position: "fixed",
        inset: 0,
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.04'/%3E%3C/svg%3E")`,
        pointerEvents: "none",
        zIndex: 0,
      }} />

      <div style={{
        position: "relative",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "480px",
        width: "100%",
      }}>
        {/* Logo */}
        <div style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(18px)",
          transition: "opacity 0.8s ease, transform 0.8s ease",
          marginBottom: "2.5rem",
        }}>
          <img
            src={logo}
            alt="Mouse Labs logo"
            style={{
              width: "300px",
              height: "300px",
              objectFit: "contain",
              mixBlendMode: "multiply",
            }}
          />
        </div>

        {/* Divider line */}
        <div style={{
          width: lineVisible ? "80px" : "0px",
          height: "1px",
          backgroundColor: "#2a2a2a",
          transition: "width 0.6s ease",
          marginBottom: "2rem",
        }} />

        {/* Tagline */}
        <div style={{
          opacity: textVisible ? 1 : 0,
          transform: textVisible ? "translateY(0)" : "translateY(10px)",
          transition: "opacity 0.7s ease, transform 0.7s ease",
          textAlign: "center",
          marginBottom: "3rem",
        }}>
          <p style={{
            fontSize: "1.05rem",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "#2a2a2a",
            margin: 0,
            fontFamily: "'Georgia', serif",
            fontStyle: "italic",
          }}>
            Curiosity, crafted.
          </p>
        </div>

        {/* Email link */}
        <div style={{
          opacity: emailVisible ? 1 : 0,
          transform: emailVisible ? "translateY(0)" : "translateY(8px)",
          transition: "opacity 0.6s ease, transform 0.6s ease",
        }}>
          <a
            href="mailto:inquiries@mouse-labs.com"
            style={{
              display: "inline-block",
              fontSize: "0.78rem",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "#2a2a2a",
              textDecoration: "none",
              borderBottom: "1px solid #2a2a2a",
              paddingBottom: "2px",
              transition: "opacity 0.2s ease",
            }}
            onMouseEnter={e => e.target.style.opacity = "0.45"}
            onMouseLeave={e => e.target.style.opacity = "1"}
          >
            Inquiries
          </a>
        </div>
      </div>

      {/* Footer */}
      <div style={{
        position: "fixed",
        bottom: "1.5rem",
        opacity: emailVisible ? 0.35 : 0,
        transition: "opacity 1s ease",
        fontSize: "0.68rem",
        letterSpacing: "0.1em",
        textTransform: "uppercase",
        color: "#2a2a2a",
        fontFamily: "'Georgia', serif",
      }}>
        © {new Date().getFullYear()} Mouse Labs
      </div>
    </div>
  );
}
